import React from 'react';
import VenueDashboardNew from './VenueDashboardNew';

const VenueDashboard = ({ venueId }) => {
  return <VenueDashboardNew venueId={venueId} />;
};


export default VenueDashboard;
